import { render, staticRenderFns } from "./custConvertListSpain.vue?vue&type=template&id=ed295af4&scoped=true&"
import script from "./custConvertListSpain.vue?vue&type=script&lang=js&"
export * from "./custConvertListSpain.vue?vue&type=script&lang=js&"
import style0 from "./custConvertListSpain.vue?vue&type=style&index=0&id=ed295af4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed295af4",
  null
  
)

export default component.exports